import React, {ReactEventHandler, ReactNode} from "react";
import "../tailwind.css";
export interface CardProps {
  children: ReactNode | null;
  clickLink?: ReactEventHandler;
  clickMenu?: ReactEventHandler;
  linkText?: string;
  theme: string;
  title: string;
}

export const Card = ({
  children,
  title = "",
  theme = "falabella",
  clickMenu,
  clickLink,
  linkText,
}: CardProps) => {
  return (
    <div
      className={`my-8 inline-block w-full max-w-md transform overflow-hidden rounded bg-white p-6 text-left align-middle shadow-md transition-all theme-${theme}`}
    >
      <div className="flex justify-between">
        <h3 className="text-lg font-medium leading-6 text-gray-900">{title}</h3>
        {clickMenu !== undefined && (
          <span className="cursor-pointer text-gray-800" onClick={clickMenu}>
            ...
          </span>
        )}
      </div>
      <div className="mt-4 text-sm text-gray-500">{children}</div>
      {clickLink !== undefined && (
        <div className="details mt-6 cursor-pointer text-sm text-blue-500 text-primary">
          <a onClick={clickLink}>{linkText}</a>
        </div>
      )}
    </div>
  );
};
